import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col, Form, Input, Button, Alert } from 'antd';

const LoginWrapper = styled.div`
  max-width: 300px;
  background-color: #fff;
  margin: 1rem auto;
  border: 1px solid #aaa;
  padding: 2rem;
`;

const Login = ({ onLoginBtnClicked, error }) => {
  return (
    <LoginWrapper>
      <Row>
        <Col span={24}>
          <h2>Login</h2>
          {error && <Alert message={error} type="error" showIcon />}
          <Form
            name="normal_login"
            className="login-form"
            layout="vertical"
            // initialValues={{
            //   username: 'ganesh@gmail.com',
            //   password: '12345678',
            // }}
            onFinish={(values) =>
              onLoginBtnClicked(values.username, values.password)
            }
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: 'Please input your Email/Username!',
                },
              ]}
            >
              <Input placeholder="Email/Username" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input your Password!',
                },
              ]}
            >
              <Input type="password" placeholder="Password" />
            </Form.Item>

            {/* <Form.Item>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Remember me</Checkbox>
              </Form.Item>
            </Form.Item> */}

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Log in
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </LoginWrapper>
  );
};

Login.defaultProps = {
  onLoginBtnClicked: () => {},
  error: false,
};

Login.propTypes = {
  onLoginBtnClicked: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default Login;
